/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SquareCode = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
    ["path", { d: "m10 10-2 2 2 2" }],
    ["path", { d: "m14 14 2-2-2-2" }]
  ]
];

export { SquareCode as default };
//# sourceMappingURL=square-code.js.map
